// Calculate trend metrics from existing asset data
export const calculateAssetTrends = (assets = []) => {
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  const monthStart = new Date(currentYear, currentMonth, 1);

  // Assets added this month
  const newAssetsThisMonth = assets.filter(asset => {
    if (!asset.createdAt) return false;
    const assetDate = new Date(asset.createdAt);
    return assetDate >= monthStart && assetDate <= now;
  }).length;

  // Assets sold/disposed this month (isSold = true)
  const disposedAssetsThisMonth = assets.filter(asset => {
    if (asset.isSold !== true) return false;

    // Use updatedAt for sold date if available
    const saleDate = asset.updatedAt ? new Date(asset.updatedAt) : new Date(asset.createdAt);
    return saleDate >= monthStart && saleDate <= now;
  }).length;

  return {
    newThisMonth: newAssetsThisMonth,
    disposedThisMonth: disposedAssetsThisMonth
  };
};
